const QuarantineStatusEnum = Object.freeze({
    CREATED_BY_API: 'CREATED_BY_API',
    CREATED_BY_ADVISER: 'CREATED_BY_ADVISER',
    PUBLISHED: 'PUBLISHED'
});

export default QuarantineStatusEnum;
